import { LatLng } from "../../utils/geocode";

export interface CoverageDistrictState {
  /** Outward code, e.g. "PL1" */
  district: string;
  /** Postcode area, e.g. "PL" */
  area: string;
  town?: string;
  centre: LatLng;
  distanceMiles: number;
  selected: boolean;
  price: number;
  /** Covered by the group's base price only — no explicit postcode price row exists. */
  implicit?: boolean;
  /** Has an unsaved local change. */
  pending?: boolean;
}

export interface WizardState {
  yardPostcode: string;
  yardOutcode?: string;
  yardLatLng?: LatLng;
  radiusMiles: number;
  defaultPrice: number;
  /** Districts whose centroid falls within the radius (the yard's own district is always included). */
  districts: CoverageDistrictState[];

  doesDropOff: boolean;
  dropOffPricePerTonne: number | null;

  sellAVehicleQuotesEnabled: boolean;
}

export const WIZARD_STEPS = [
  { id: "location", name: "Your yard" },
  { id: "coverage", name: "Coverage area" },
  { id: "pricing", name: "Prices" },
  { id: "dropoff", name: "Drop-offs" },
  { id: "sellavehicle", name: "SellAVehicle" },
  { id: "review", name: "Finish" },
] as const;

export type WizardStepId = (typeof WIZARD_STEPS)[number]["id"];

export const formatGbp = (value: number) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(value);
